import { Button } from "@capacit-com/lara-law-shared-ui";
import React from "react";
import type { ChatConnectionState } from "@/providers/ConversationHubProvider";

type ConnectionStatusProps = {
  connectionState: ChatConnectionState;
  onReconnect: () => void;
};

const ConnectionStatus: React.FC<ConnectionStatusProps> = ({
  connectionState,
  onReconnect,
}) => {
  if (connectionState === "Connected") return null;

  return (
    <div className="p-2 rounded-md text-white text-sm bg-destructive text-destructive-foreground">
      <div className="gap-2 items-center flex">
        <span>
          Kunne ikke oprette forbindelse. Check din internetforbindelse.
        </span>
        <Button onClick={onReconnect}>Prøv igen</Button>
      </div>
    </div>
  );
};

export default ConnectionStatus;
